import React, { useState } from "react";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { useParams } from "react-router-dom";

import Tabs from "../../../../components/elements/Tabs";
import OrderDetailsTab from "./OrderDetailsTab";
import ShippingInfoTab from "./ShippingInfoTab";
import BillingInfoTab from "./BillingInfoTab";
import { orderDetails } from "../../../../services/orderService";
import useFetch from "../../../../hooks/useFetch";
import { Copy } from "lucide-react";

const OrderDetails = ({ item }) => {
  console.log(item, "order id");
  const orderId = item?.orderId;

  const [copied, setCopied] = useState(false);
  const { data: orderData, isLoading } = useFetch({
    dependencies: ["details", orderId],
    fetchFunction: async () => {
      const res = await orderDetails({ orderId, type: "admin" });
      if (res?.status === 200) return res.data;
      toast.warning(res?.message);
      return {};
    },
  });

  const statusColor = {
    delivered: "#06D6A0",
    shipped: "#4f46e5",
    returnRequest: "#fb923c",
    returnConfirmed: "#06D6A0",
    pickup: "#06D6A0",
    pending: "#bc93e4",
    Cancelled: "#ef427c",
    Awaiting: "#bc93e4",
    processing: "#4f46e5",
    exchangeRequest: "#fb923c",
    exchangeConfirmed: "#06D6A0",
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  const totalAmount = orderData?.items?.reduce(
    (sum, item) => sum + item.totalPrice,
    0
  );

  if (isLoading) return <div className="p-10">Loading...</div>;

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-blue-50 p-4">
      <div className="max-w-6xl mx-auto mb-6">
        <div className="bg-white rounded-2xl shadow-xl p-6 border border-purple-100">
          <div className="mb-3">
            {/* <h1 className="text-2xl font-bold text-gray-800">
              Order ID: <span className="font-mono">{orderData?.orderId}</span>
            </h1> */}
            <div className="flex items-center gap-3">
              <span className="text-lg text-gray-600">Order ID:</span>
              <div className="flex items-center gap-1 md:gap-2 bg-gray-100 px-3 py-1 rounded-lg">
                <span className="font-mono text-sm text-gray-800">
                  {orderData.orderId}
                </span>
                <button
                  onClick={() => copyToClipboard(orderData.orderId)}
                  className="p-1 hover:bg-gray-200 rounded transition-colors"
                >
                  <Copy className="w-4 h-4 text-gray-500" />
                </button>
              </div>
              {copied && (
                <span className="text-green-600 text-sm animate-pulse">
                  Copied!
                </span>
              )}
            </div>
            <p className="text-gray-500">
              Created At: {dayjs(orderData?.createdAt).format("D MMMM, YYYY")}
            </p>
          </div>

          <div className="flex justify-between items-center">
            <div className="text-sm font-medium">
              Status:
              <span
                className="ml-2 px-3 py-1 text-white rounded-full"
                style={{
                  backgroundColor: statusColor[orderData?.status] || "#ccc",
                }}
              >
                {orderData?.status}
              </span>
            </div>
            <div className="text-right">
              <div className="text-sm text-gray-600">
                Items: {orderData?.items?.length}
              </div>
              <div className="text-lg font-bold text-gray-800">
                Total: ${orderData?.subtotal?.toFixed(2)}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto">
        <Tabs
          defaultActiveKey={0}
          tabsClass="gap-8 border-b border-gray-200"
          items={[
            {
              label: "Order Details",
              icon: "fa-solid fa-box",
              content: (
                <OrderDetailsTab
                  items={orderData?.items || []}
                  bookData={orderData?.bookData || {}}
                />
              ),
            },
            {
              label: "Shipping Info",
              icon: "fa-solid fa-truck",
              content: (
                <ShippingInfoTab shippingAddress={orderData?.shippingAddress} />
              ),
            },
            {
              label: "Billing Info",
              icon: "fa-solid fa-credit-card",
              content: (
                <BillingInfoTab
                  billingAddress={orderData?.billingAddress}
                  user={orderData?.user}
                  invoiceNumber={orderData?.invoiceNumber}
                />
              ),
            },
          ]}
        />
      </div>
    </div>
  );
};

export default OrderDetails;
